import { useMutation, useQuery } from "@tanstack/react-query";
import { dropinApi } from "@bw/shared/api";
import type {
  DropInCancellationDecisionResponse,
  DropInCancellationRequest,
  DropInCancellationResponse,
} from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

export function useDropInCancellationDecision(
  facilityId: string,
  sessionId: string,
  enabled: boolean,
) {
  return useQuery<DropInCancellationDecisionResponse>({
    queryKey: queryKeys.dropin.cancellation(facilityId, sessionId),
    queryFn: () => dropinApi.getCancellationDecision(facilityId, sessionId),
    enabled: Boolean(facilityId && sessionId && enabled),
    staleTime: 0,
    retry: false,
  });
}

export function useCancelDropInSession(facilityId: string, sessionId: string) {
  return useMutation<
    DropInCancellationResponse,
    unknown,
    DropInCancellationRequest
  >({
    mutationFn: (request) =>
      dropinApi.cancelSession(facilityId, sessionId, request),
  });
}

export function useRecoverDropInCancellation(
  facilityId: string,
  sessionId: string,
) {
  return useMutation<DropInCancellationResponse, unknown, void>({
    mutationFn: () => dropinApi.recoverCancellation(facilityId, sessionId),
  });
}
